// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { IPageComponentData, pageComponentData } from 'src/app/features/page-component/models/page-component-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { claimRefDto, ClaimRefDto, IClaimRefDto } from './claim-ref-dto.g';

export const pageComponentDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    deleted: 'deleted',
    inactive: 'inactive',
    claimsDto: 'claimsDto',
} as const;

export type TPageComponentDto = (typeof pageComponentDto)[keyof typeof pageComponentDto];

export const pageComponentDtoConstraints = {
    name: { required: true, maxLength: 20 },
    guid: { required: true },
} as const;

export type TPageComponentDtoConstraints = typeof pageComponentDtoConstraints;

export interface IPageComponentDto extends ILevelGeneralDto {
    [pageComponentDto.guid]: string | null;
    [pageComponentDto.nr]: number | null;
    [pageComponentDto.name]: string | null;
    [pageComponentDto.deleted]: boolean | null;
    [pageComponentDto.inactive]: boolean | null;
    [pageComponentDto.claimsDto]: IClaimRefDto[] | null;
}

export class PageComponentDto
    implements IPageComponentDto
{
    [pageComponentDto.guid]: string | null = null;
    [pageComponentDto.nr]: number | null = null;
    [pageComponentDto.name]: string | null = null;
    [pageComponentDto.deleted]: boolean | null = null;
    [pageComponentDto.inactive]: boolean | null = null;
    [pageComponentDto.claimsDto]: IClaimRefDto[] | null = null;

    private constructor(
        modelData?: IPageComponentData, includeRefs = true
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[pageComponentDto.guid] = modelData[pageComponentData.guid];
        this[pageComponentDto.nr] = modelData[pageComponentData.nr];
        this[pageComponentDto.name] = modelData[pageComponentData.name];
        this[pageComponentDto.deleted] = modelData[pageComponentData.deleted];
        this[pageComponentDto.inactive] = modelData[pageComponentData.inactive];

        if (!includeRefs) return;

        this[pageComponentDto.claimsDto] = modelData[pageComponentData.claimsData]
            ?.map(item => ClaimRefDto.create(item))
            .filter((a): a is IClaimRefDto => a !== null)
            .sort((a, b) => (a[claimRefDto.name] ?? '').localeCompare(b[claimRefDto.name] ?? ''))
            ?? null;
    }

    static create(modelData?: IPageComponentData | null, includeRefs = true): IPageComponentDto | null {
        return modelData ? new PageComponentDto(modelData, includeRefs) : null;
    }
}
